<!-- PROCESO AUTO -->
@if (!operation?.config?.iframe) {
    <tec-pwcs-layout
        [ngClass]="{
            dark: darkModeEnabled,
            'hide-subtitle': !(operation?.config.tutorial || pageWarning.show || handsetLandscape || polTutorialSubtitleHandoff)
        }"
        [title]="pageWarning.type === PAGE_WARNING.HELP ? ('LIFE_CHECK.HELP.TITLE' | translate) : ''"
        [subtitle]="layoutSubtitle"
        [footerLabel]="
            operation?.config.tutorial && !pageWarning.show && permissionsCamera && !handsetLandscape
                ? ('GENERAL.TUTORIAL_ENCRYPTION' | translate)
                : ''
        "
    >
        <tec-progress [value]="lifeCheckProgressValue"></tec-progress>

        <!-- CONTROLES -->
        @if (testMode && !env.production) {
            <tec-topnav [img]="'assets/images/tecalis-sm.svg'">
                <ng-container [ngTemplateOutlet]="allControls"></ng-container>
            </tec-topnav>
        }

        <!-- TUTORIAL -->
        @if (operation?.config.tutorial && !pageWarning.show && permissionsCamera && !handsetLandscape) {
            <tec-alert
                [msg]="'LIFE_CHECK.TUTORIAL_TIP' | translate"
                type="message"
                status="success"
                hiddenCloseButton
            ></tec-alert>
        }

        <!-- CONTENT -->
        <ng-container content [ngTemplateOutlet]="fullContent"> </ng-container>

        <!-- ACTIONS -->
        <ng-container actions [ngTemplateOutlet]="fullActions"> </ng-container>

        <!-- NAV HELP -->
        @if (permissionsCamera && !pageWarning.show && !handsetLandscape) {
            <tec-nav-help
                [elements]="operation?.config?.tutorial ? navsHelpTutorial : navsHelp"
                (clickEvent)="navHelpChange($event)"
            ></tec-nav-help>
        }

        <!-- WATERMARK -->
        @if ((designService.configDesign$ | async)?.showWatermark) {
            <tec-watermark type="default" />
        }
    </tec-pwcs-layout>
}

<!-- IFRAME -->
@if (operation?.config?.iframe) {
    <tec-pwcs-layout
        [ngClass]="{ 'pwcs-style-old': true, dark: darkModeEnabled }"
        [title]="pageWarning.type === PAGE_WARNING.HELP ? ('LIFE_CHECK.HELP.TITLE' | translate) : ''"
        [subtitle]="layoutSubtitle"
        [footerLabel]="
            operation?.config.tutorial && !pageWarning.show && permissionsCamera && !handsetLandscape
                ? ('GENERAL.TUTORIAL_ENCRYPTION' | translate)
                : ''
        "
    >
        <!-- CONTROLES -->
        @if (testMode && !env.production) {
            <tec-topnav [img]="'assets/images/tecalis-sm.svg'">
                <ng-container [ngTemplateOutlet]="allControls"></ng-container>
            </tec-topnav>
        }

        <!-- TUTORIAL -->
        @if (operation?.config.tutorial && !pageWarning.show && permissionsCamera && !handsetLandscape) {
            <tec-alert
                [msg]="'LIFE_CHECK.TUTORIAL_TIP' | translate"
                type="message"
                status="success"
                hiddenCloseButton
            ></tec-alert>
        }

        <!-- CONTENT -->
        <ng-container content [ngTemplateOutlet]="fullContent"></ng-container>

        <!-- ACTIONS -->
        <ng-container actions [ngTemplateOutlet]="fullActions"></ng-container>
    </tec-pwcs-layout>
}

<ng-template #allControls>
    @if (allCameras && allCameras.length > 1) {
        <tec-icon name="icon-rotate-camera" (click)="changeCamera()"></tec-icon>
    }
    <!-- <tec-switch size="sm" label="Dark mode" [formControl]="darkMode"></tec-switch> -->
    <tec-switch
        size="sm"
        label="Ctrl"
        [formControl]="formRect"
        (valueChange)="positionFaceService.setDraw($event)"
    ></tec-switch>
    <tec-switch size="sm" label="Stats" [formControl]="formStats"></tec-switch>
    @if (formStats.value && controls) {
        <div class="stats">
            <b>Proceso: {{ controls.lifeTestId }}</b>
            @if (lifeCheckConf.general.type === 'random') {
                <span> Aleatorias: {{ lifeTestCompleted() }} de {{ lifeCheckConf?.general?.totalLifeTest || 0 }} </span>
            }
            @if (lifeCheckConf.general.type === 'random-repeat') {
                <span>
                    Aleatorias con repetición: {{ lifeTestCompleted() }} de
                    {{ lifeCheckConf?.general?.totalLifeTest || 0 }}
                </span>
            }
            @if (lifeCheckConf.general.type === 'lineal') {
                <span> Lineales: {{ lifeTestCompleted() }} de {{ lifeCheckConf?.general?.totalLifeTest || 0 }} </span>
            }
            @if (!isHuman) {
                <span>No se detecta cara</span>
            }
            <span>Parpadeos totales: {{ controls.totalBlinks || 0 }}</span>
            <span>Parpadeos totales 2 medidas: {{ controls.totalBlinksWith2 || 0 }}</span>
            <span>Parpadeos totales 1 medida: {{ controls.totalBlinksWith1 || 0 }}</span>
            <span>Tiempo total: {{ timerManagerService.totalTime }} seg</span>
            <span>Tiempo warning: {{ timerManagerService.warningTime }} seg</span>
            <span>Tiempo sin cara: {{ timerManagerService.noFaceTime }} seg</span>
            <b>Emoción</b>
            @if (!!lifeCheckConf?.general?.minPercenteageTimeInMiddle) {
                <span>
                    % Min centrado: {{ lifeCheckConf.general.minPercenteageTimeInMiddle }}% =>
                    {{ controls.percentageTimeInCamera || 0 | number: '1.0-2' }}%
                </span>
            }
            @if (!!controls.minPercentageFaceBlendshape) {
                <span
                    >% Min emoción: {{ controls.minPercentageFaceBlendshape }}% =>
                    {{ controls.percentageLifeTest || 0 | number: '1.0-2' }}%</span
                >
            }
            @if (!!controls.minPercentageTransition) {
                <span
                    >Min transiciones: {{ controls.minPercentageTransition }} =>
                    {{ controls.percentageTransition || 0 | number: '1.0-2' }}</span
                >
            }
            @if (controls.noseMovement) {
                <b>Movimiento de la nariz</b>
                <span
                    >% Min variación: {{ controls.noseMovement.minPercentageVariance }}% =>
                    {{ controls.noseMovement?.percentageVariance || 0 | number: '1.0-2' }}%</span
                >
                <span
                    >Min distancia: {{ controls.noseMovement.minDistance }} =>
                    {{ controls.noseMovement?.distance || 0 | number: '1.0-2' }}</span
                >
                <span
                    >Min transiciones: {{ controls.noseMovement.minTransitions }} =>
                    {{ controls.noseMovement?.transitions || 0 | number: '1.0-2' }}</span
                >
            }
            <b>Comparación imágenes</b>
            <span
                >% Min similitud foto: {{ lifeCheckConf.general.minEnvironmentSimilarityPercenteage }} =>
                {{ controls.similarityPercentage?.environment || 0 | number: '1.0-2' }}%</span
            >
            <span
                >% Min similitud cara: {{ lifeCheckConf.general.minFaceSimilarityPercenteage }} =>
                {{ controls.similarityPercentage?.face || 0 | number: '1.0-2' }}%</span
            >
            <span
                >% Min similitud total: {{ lifeCheckConf.general.minTotalSimilarityPercenteage }} =>
                {{ lifeCheckConf.general?.scoring?.similarityPercentage || 0 | number: '1.0-2' }}%</span
            >
            @if (lifeCheckConf.middleFace.scoring) {
                <b
                    style="display: flex; gap: 5px; cursor: pointer"
                    (click)="controls.showMiddleFaceScoring = !controls.showMiddleFaceScoring"
                >
                    <tec-icon [name]="!controls.showMiddleFaceScoring ? 'icon-plus' : 'icon-minus'"></tec-icon>
                    Scoring: {{ lifeCheckConf.middleFace.lifeTestId }} =>
                    {{ lifeCheckConf.middleFace.scoring.result || 0 }}
                </b>
                @if (controls.showMiddleFaceScoring) {
                    @for (item of lifeCheckConf.middleFace.scoring | keyvalue; track item) {
                        <span>
                            @if (item.key !== 'result') {
                                {{ item.key }}: {{ item.value | number: '1.0-2' }}
                            }
                        </span>
                    }
                }
            }
            @for (lt of lifeCheckConf.lifeTest; track lt) {
                @if (lt.scoring) {
                    <b
                        style="display: flex; gap: 5px; cursor: pointer"
                        (click)="controls['show' + lt.lifeTestId] = !controls['show' + lt.lifeTestId]"
                    >
                        <tec-icon [name]="!controls['show' + lt.lifeTestId] ? 'icon-plus' : 'icon-minus'"></tec-icon>
                        Scoring: {{ lt.lifeTestId }} => {{ lt.scoring.result || 0 }}
                    </b>
                    @if (controls['show' + lt.lifeTestId]) {
                        @for (item of $any(lt.scoring) | keyvalue; track item) {
                            <span>
                                @if (item.key !== 'result') {
                                    {{ item.key }}: {{ $any(item.value) | number: '1.0-2' }}
                                }
                            </span>
                        }
                    }
                }
            }
            @if (lifeCheckConf.general.scoring) {
                <b
                    style="display: flex; gap: 5px; cursor: pointer"
                    (click)="controls.showGeneralScoring = !controls.showGeneralScoring"
                >
                    <tec-icon [name]="controls.showGeneralScoring ? 'icon-plus' : 'icon-minus'"></tec-icon>
                    Scoring: general => {{ lifeCheckConf.general.scoring.result || 0 }}
                </b>
                @if (!controls.showGeneralScoring) {
                    @for (item of lifeCheckConf.general.scoring | keyvalue; track item) {
                        <span>
                            @if (item.key !== 'result') {
                                {{ item.key }}: {{ item.value | number: '1.0-2' }}
                            }
                        </span>
                    }
                }
            }
            @if (false && allCameras && allCameras.length > 1) {
                <b>Cámaras: {{ controls?.activeCamera | json }}</b>
                <span>{{ controls?.mediaDevices | json }}</span>
            }
            @if (false) {
                <b
                    >TTS: {{ tts.isTTSAvailable() ? 'disponible' : 'no disponible' }} -
                    {{ languageService.getLanguage() }}</b
                >
                @if (tts.isTTSAvailable()) {
                    @if (tts.getAvailableVoices().length) {
                        <ul>
                            @for (lang of tts.getAvailableVoices(); track lang) {
                                <li>{{ lang.name }}</li>
                            }
                        </ul>
                    }
                    @if (!tts.getAvailableVoices().length) {
                        <span>Ningún idioma</span>
                    }
                }
            }
        </div>
    }
</ng-template>

<ng-template #face>
    <!-- MAIN -->
    <div
        class="content__identity"
        [ngStyle]="{
            display: operation?.config.tutorial || pageWarning.show || handsetLandscape ? 'none' : 'contents'
        }"
    >
        @if (loading.show) {
            <tec-spinner
                [show]="loading.show"
                [opaque]="true"
                [text]="loading.text"
                [img]="designService.getCustomSpinnerUrl() || undefined"
            ></tec-spinner>
        }
        <div class="scan-face-wrap" [class.pol-preview--pc]="isPolPreviewPc">
            <tec-scan-face
                [hidden]="loading.show"
                [done]="done"
                [match]="getPolScanFaceMatch()"
                [smile]="scanFaceAnimation?.smile"
                [grow]="scanFaceAnimation?.grow"
                [check]="scanFaceAnimation?.check"
                [halfRight]="scanFaceAnimation?.halfRight"
                [halfLeft]="scanFaceAnimation?.halfLeft"
                [halfTop]="scanFaceAnimation?.halfTop"
                [halfBottom]="scanFaceAnimation?.halfBottom"
                [showArrow]="scanFaceAnimation?.showArrow"
                [positionArrow]="scanFaceAnimation?.positionArrow"
                [progressValue]="scanFaceAnimation?.progressValue"
                [alertText]="alertScanFaceText"
            >
                @if (!forceVideoRemount) {
                    <app-video
                        [fillParent]="true"
                        [debugMode]="formRect?.value"
                        [animationFrame]="animationFrame"
                        [constraints]="lifeCheckService.constraints"
                        [zoomFactor]="getEffectivePolPreviewZoomFactor()"
                        [zoomTransformOrigin]="'center center'"
                        [discardStaleInheritedStream]="true"
                        (cameraError)="onCameraError($event)"
                        (cameraPermissionRevoked)="onCameraPermissionRevoked()"
                        (cameraStarted)="onCameraStarted($event)"
                        (cameraSwitchStarted)="onCameraSwitchStarted()"
                        (cameraSwitchCompleted)="onCameraSwitchCompleted()"
                        (cameraChanged)="onCameraChanged()"
                    ></app-video>
                }
            </tec-scan-face>
            @if (!loading.show && (middleFaceMinTimeCountdownSeconds ?? approachFaceHoldCountdownSeconds) != null) {
                <div class="scan-face-min-time-countdown" aria-live="polite">
                    {{ middleFaceMinTimeCountdownSeconds ?? approachFaceHoldCountdownSeconds }}
                </div>
            }
        </div>

        @if (!loading.show && (!alertContent.label || !alertContent.status)) {
            <span class="content__identity__subtitle-mobile" [innerHTML]="subtitle"></span>
        }

        <div class="tec-alert--float">
            @if (!loading.show && alertContent.label && alertContent.status) {
                <tec-alert
                    hiddenCloseButton
                    type="message"
                    [status]="alertContent.status"
                    [msg]="alertContent.label"
                    [icon]="alertContent.icon"
                ></tec-alert>
            }
        </div>

        <!-- BOTON CAMBIO CAMARA -->
        @if (operation?.config?.iframe && allCameras && allCameras.length > 1) {
            <div class="change-camera">
                <span>{{ 'GENERAL.BUTTON.CHANGE_CAMERA' | translate }}</span>
                <tec-button-icon
                    icon="icon-refresh"
                    type="circle"
                    size="lg"
                    (clickEvent)="changeCamera()"
                ></tec-button-icon>
            </div>
        }

        <!-- QR -->
        @if (operation?.config?.iframe && !loading.show) {
            <div [ngClass]="{ widget: true, open: openQR }">
                <div class="widget__intro">
                    <h6>{{ 'GENERAL.QR.TITLE' | translate }}</h6>
                    <span>{{ 'GENERAL.QR.DESCRIPTION' | translate }}</span>
                </div>
                <div class="widget__content">
                    <div class="widget__content__qr" id="qrcode2" [title]="qrUrl">
                        <tec-qr [url]="qrUrl" />
                    </div>
                    <p class="widget__content__url">{{ qrUrl }}</p>
                </div>
                <button class="button button-icon" (click)="openQR = !openQR">
                    <i class="icon-chevron-down"></i>
                </button>
            </div>
        }
        <!-- Imágenes auxiliares -->
        <div style="display: none">
            <img id="uploadImage1" />
            <img id="uploadImage2" />
        </div>
    </div>

    @if (testMode) {
        <div class="input-example">
            <tec-input [formControl]="dataToParent"></tec-input>
            <tec-button (click)="sendDataIframe(IFRAME_RESULT.OK)" size="xs">Send data to parent</tec-button>
            @if (parentMsg) {
                <div>Msg del padre: {{ parentMsg | json }}</div>
            }
        </div>
    }
    <!-- <div style="display: flex;" *ngIf="testMode">
        <b>Log audios</b>
        <ng-container>
            {{ audioService.audiolog | json}}
        </ng-container>
    </div> -->
</ng-template>

<ng-template #fullContent>
    <!-- SIN PERMISOS -->
    @if (!permissionsCamera) {
        <tec-tile
            type="status"
            [title]="'GENERAL.ERROR.NO_PERMISSION_CAMERA_TITLE' | translate"
            [subtitle]="'GENERAL.ERROR.NO_PERMISSION_CAMERA_DESCRIPTION' | translate"
            icon="icon-alert"
        >
            <tec-link
                [label]="'LIFE_CHECK.HELP.TITLE' | translate"
                (click)="isVisibleHelpNoPermissionsCamera = true"
            ></tec-link>
        </tec-tile>
    }

    <!-- CON PERMISOS -->
    @if (permissionsCamera) {
        <!-- TUTORIAL -->
        @if (operation?.config.tutorial && !pageWarning.show && !handsetLandscape) {
            <div class="tutorial-image">
                <div class="pwcs-lottie-frame">
                    <ng-lottie
                        [options]="
                            tutorialLottieOptions || {
                                path: darkModeEnabled
                                    ? 'assets/animations/pwcs-prueba-vida-dark.json'
                                    : 'assets/animations/pwcs-prueba-vida-light.json'
                            }
                        "
                    ></ng-lottie>
                </div>
                <!-- <img [src]="designService.isDarkMode() ? 'assets/images/tuto-lifecheck-dark.svg' : 'assets/images/tuto-lifecheck.svg'"> -->
            </div>
        }

        <!-- FACE -->
        <ng-container [ngTemplateOutlet]="face"> </ng-container>

        <!-- HELP -->
        @if (pageWarning.show) {
            @if (pageWarning.type === PAGE_WARNING.HELP) {
                <div class="tile tile--help">
                    <div class="image-group">
                        <pwcs-inline-svg
                            [src]="'assets/images/kyc-blur' + (darkModeEnabled ? '-dark' : '') + '.svg'"
                            idSuffix="life-check-help-kyc-blur"
                        />
                        <p>
                            <span>{{ 'LIFE_CHECK.MODAL_HELP.TIP_1' | translate }}</span>
                        </p>
                    </div>
                    <div class="image-group">
                        <pwcs-inline-svg
                            [src]="'assets/images/kyc-bright' + (darkModeEnabled ? '-dark' : '') + '.svg'"
                            idSuffix="life-check-help-kyc-bright"
                        />
                        <p>
                            <span>{{ 'LIFE_CHECK.MODAL_HELP.TIP_2' | translate }}</span>
                        </p>
                    </div>
                    <div class="image-group">
                        <pwcs-inline-svg
                            [src]="'assets/images/kyc-cut' + (darkModeEnabled ? '-dark' : '') + '.svg'"
                            idSuffix="life-check-help-kyc-cut"
                        />
                        <p>
                            <span>{{ 'LIFE_CHECK.MODAL_HELP.TIP_3' | translate }}</span>
                        </p>
                    </div>
                    <div class="image-group">
                        <pwcs-inline-svg
                            [src]="'assets/images/kyc-glasses' + (darkModeEnabled ? '-dark' : '') + '.svg'"
                            idSuffix="life-check-help-kyc-glasses"
                        />
                        <p>
                            <span>{{ 'LIFE_CHECK.MODAL_HELP.TIP_4' | translate }}</span>
                        </p>
                    </div>
                </div>
                <tec-alert
                    [msg]="'OCR.BACK.MODAL_HELP.TIP_5' | translate"
                    type="message"
                    hiddenCloseButton
                    icon="icon-info"
                ></tec-alert>
            }
            @if (pageWarning.type === PAGE_WARNING.NO_FACE) {
                <tec-tile
                    type="status"
                    [title]="'LIFE_CHECK.PAGE_WARNING.NO_FACE.TITLE' | translate"
                    [subtitle]="'LIFE_CHECK.PAGE_WARNING.NO_FACE.DESCRIPTION' | translate"
                    icon="icon-alert"
                ></tec-tile>
            }
            @if (pageWarning.type === PAGE_WARNING.MULTIPLE_FACES) {
                <tec-tile
                    type="status"
                    [title]="'LIFE_CHECK.PAGE_WARNING.MULTIPLE_FACES.TITLE' | translate"
                    [subtitle]="'LIFE_CHECK.PAGE_WARNING.MULTIPLE_FACES.DESCRIPTION' | translate"
                    icon="icon-alert"
                ></tec-tile>
            }
            @if (pageWarning.type === PAGE_WARNING.VERIFICATION_FAIL) {
                <tec-tile
                    type="status"
                    [title]="'LIFE_CHECK.PAGE_WARNING.VERIFICATION_FAIL.TITLE' | translate"
                    [subtitle]="'LIFE_CHECK.PAGE_WARNING.VERIFICATION_FAIL.DESCRIPTION' | translate"
                    icon="icon-alert"
                ></tec-tile>
            }
            @if (pageWarning.type === PAGE_WARNING.SERVER_ERROR) {
                <tec-tile
                    type="status"
                    [title]="'LIFE_CHECK.PAGE_WARNING.SERVER_ERROR.TITLE' | translate"
                    [subtitle]="'LIFE_CHECK.PAGE_WARNING.SERVER_ERROR.DESCRIPTION' | translate"
                    icon="icon-alert"
                ></tec-tile>
            }
            @if (pageWarning.type === PAGE_WARNING.CAMERA_ERROR) {
                <tec-tile
                    type="status"
                    [title]="'LIFE_CHECK.PAGE_WARNING.CAMERA_ERROR.TITLE' | translate"
                    [subtitle]="'LIFE_CHECK.PAGE_WARNING.CAMERA_ERROR.DESCRIPTION' | translate"
                    icon="icon-alert"
                ></tec-tile>
            }
            @if (pageWarning.type === PAGE_WARNING.BACK_TO_OCR) {
                <tec-tile
                    type="status"
                    [title]="backToOcrTitleKey | translate"
                    [subtitle]="backToOcrShowSubtitle ? ('LIFE_CHECK.PAGE_WARNING.BACK_TO_OCR.DESCRIPTION' | translate) : ''"
                    icon="icon-alert">
                    <tec-tile>
                        <div class="grid grid-e3-sm">
                            <div class="image-group">
                                <pwcs-inline-svg
                                    [src]="'assets/images/id-bright' + (darkModeEnabled ? '-dark' : '') + '.svg'"
                                    idSuffix="life-check-back-ocr-id-bright"
                                />
                                <span>{{ 'OCR.BACK.MODAL_HELP.TIP_2' | translate }}</span>
                            </div>
                            <div class="image-group">
                                <pwcs-inline-svg
                                    [src]="'assets/images/id-cut' + (darkModeEnabled ? '-dark' : '') + '.svg'"
                                    idSuffix="life-check-back-ocr-id-cut"
                                />
                                <span>{{ 'OCR.BACK.MODAL_HELP.TIP_3' | translate }}</span>
                            </div>
                            <div class="image-group">
                                <pwcs-inline-svg
                                    [src]="'assets/images/id-finger' + (darkModeEnabled ? '-dark' : '') + '.svg'"
                                    idSuffix="life-check-back-ocr-id-finger"
                                />
                                <span>{{ 'OCR.BACK.MODAL_HELP.TIP_4' | translate }}</span>
                            </div>
                        </div>
                    </tec-tile>
                </tec-tile>
            }
        }
        <!-- HANDSETLANDSCAPE -->
        @if (handsetLandscape && !pageWarning.show) {
            <app-handset-landscape-tile />
        }
    }
</ng-template>

<ng-template #fullActions>
    <!-- SIN PERMISOS -->
    @if (!permissionsCamera) {
        <tec-button type="secondary" [size]="'lg'" (clickEvent)="isVisibleChangeDevice = true">
            {{ 'GENERAL.BUTTON.OTHER_DEVICE' | translate }}
        </tec-button>
        <tec-button [size]="'lg'" (clickEvent)="checkPermissions()">
            {{ 'GENERAL.BUTTON.PERMISSIONS_ACTIVATED' | translate }}
        </tec-button>
    }

    <!-- CON PERMISOS -->
    @if (permissionsCamera) {
        <!-- TUTORIAL -->
        @if (operation?.config.tutorial && !pageWarning.show && !handsetLandscape) {
            <tec-button
                [label]="'GENERAL.BUTTON.IM_READY' | translate"
                [type]="'default'"
                [size]="'lg'"
                (clickEvent)="finishTutorial()"
            ></tec-button>
        }

        <!-- HELP -->
        @if (pageWarning.show) {
            @if (pageWarning.type === PAGE_WARNING.HELP) {
                <!-- DESDE tec-nav-help -->
                @if (isHelpByNavHelp) {
                    <tec-button
                        [label]="'GENERAL.BUTTON.CHANGE_DEVICE' | translate"
                        [type]="'secondary'"
                        [size]="'lg'"
                        (clickEvent)="changeDevice()"
                    ></tec-button>
                    <tec-button
                        [label]="'GENERAL.BUTTON.GO_BACK' | translate"
                        [type]="'default'"
                        [size]="'lg'"
                        (clickEvent)="retryAllProcess('Button ' + PAGE_WARNING.HELP)"
                    ></tec-button>
                }
                <!-- DESDE SEGUNDO INTENTO -->
                @if (!isHelpByNavHelp) {
                    <tec-button
                        [label]="'GENERAL.BUTTON.RETRY' | translate"
                        [type]="'secondary'"
                        [size]="'lg'"
                        (clickEvent)="retryAllProcess('Button ' + PAGE_WARNING.HELP)"
                    ></tec-button>
                    <tec-button
                        [label]="'GENERAL.BUTTON.CHANGE_DEVICE' | translate"
                        [type]="'default'"
                        [size]="'lg'"
                        (clickEvent)="changeDevice()"
                    ></tec-button>
                }
            }
            @if (pageWarning.type === PAGE_WARNING.NO_FACE) {
                <tec-button
                    [label]="'GENERAL.BUTTON.RESET_POL' | translate"
                    [type]="'default'"
                    (clickEvent)="retryAllProcess('Button ' + PAGE_WARNING.NO_FACE)"
                ></tec-button>
            }
            @if (pageWarning.type === PAGE_WARNING.MULTIPLE_FACES) {
                <tec-button
                    [label]="'GENERAL.BUTTON.RESET_POL' | translate"
                    [type]="'default'"
                    (clickEvent)="retryAllProcess('Button ' + PAGE_WARNING.MULTIPLE_FACES)"
                ></tec-button>
            }
            @if (pageWarning.type === PAGE_WARNING.CAMERA_ERROR && !operation.config.iframe) {
                <tec-button
                    [label]="'GENERAL.BUTTON.RETRY' | translate"
                    [type]="'default'"
                    [size]="'lg'"
                    (clickEvent)="retryAllProcess('Button ' + PAGE_WARNING.CAMERA_ERROR)"
                ></tec-button>
            }
            @if (operation.config.iframe) {
                @if (pageWarning.type === PAGE_WARNING.VERIFICATION_FAIL) {
                    <tec-button
                        [label]="'GENERAL.BUTTON.EXIT' | translate"
                        [type]="'default'"
                        (clickEvent)="sendDataIframe(IFRAME_RESULT.KO)"
                    ></tec-button>
                }
                @if (pageWarning.type === PAGE_WARNING.SERVER_ERROR) {
                    <tec-button
                        [label]="'GENERAL.BUTTON.EXIT' | translate"
                        [type]="'default'"
                        (clickEvent)="sendDataIframe(IFRAME_RESULT.CANCEL, PAGE_WARNING.SERVER_ERROR)"
                    ></tec-button>
                }
                @if (pageWarning.type === PAGE_WARNING.CAMERA_ERROR) {
                    <tec-button
                        [label]="'GENERAL.BUTTON.EXIT' | translate"
                        [type]="'default'"
                        (clickEvent)="sendDataIframe(IFRAME_RESULT.CANCEL, PAGE_WARNING.CAMERA_ERROR)"
                    ></tec-button>
                }
            }
        }
    }
</ng-template>

<app-modal-scan-qr
    [ngClass]="{ 'pwcs-style-old': operation.config?.iframe, dark: darkModeEnabled }"
    [(isVisible)]="isVisibleScan"
    [url]="qrUrl"
></app-modal-scan-qr>

<app-modal-help-no-camera-permissions
    [ngClass]="{ 'pwcs-style-old': operation.config?.iframe, dark: darkModeEnabled }"
    [(isVisible)]="isVisibleHelpNoPermissionsCamera"
    [url]="qrUrl"
></app-modal-help-no-camera-permissions>

<app-modal-change-device
    [ngClass]="{ 'pwcs-style-old': operation.config?.iframe, dark: darkModeEnabled }"
    [(isVisible)]="isVisibleChangeDevice"
    [url]="qrUrl"
></app-modal-change-device>
